import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { primary_s5_l70 } from '../../../shared/lib/colors';
import { FiChevronDown } from 'react-icons/fi';
import { FaFilePdf } from 'react-icons/fa';
import moment from 'moment';

import Price from '../../../shared/Price/Price';
import CartQuantity from '../../../shared/CartQuantity/CartQuantity';
import ItemSlider from '../../../shared/ItemSlider/ItemSlider';
import ProductThumbnail from '../../../shared/ProductThumbnail/ProductThumbnail';
import MessaggioChiusura from '../../../shared/MessaggioChiusura/MessaggioChiusura';
import A from '../../../shared/Anchor/Anchor';
import Button from '../../../shared/Button/Button';
import Breadcrumb from '../../../shared/Breadcrumb/Breadcrumb';
import Cart from '../../../shared/Icons/Cart';
import Tick from '../../../shared/Icons/Tick';

import {
  addToCart,
  isInCart,
  getMaxAddable,
  quantityInCart,
} from '../../../../redux/modules/cart';
import { addToCartEvent } from '../../../shared/lib/gaEnhancedEcommerce';

import {
  loadPrice,
  loadBoughtTogether,
  loadSimilar,
  loadFreeProducts,
} from '../../../../redux/modules/singleProduct';

import './DettaglioProdotto.scss';
import Resi from '../../../shared/Icons/Resi';
import Autorizzate from '../../../shared/Icons/Autorizzate';
import Consegne from '../../../shared/Icons/Consegne';
import PagamentiSicuri from '../../../shared/Icons/PagamentiSicuri';
import Timer from '../../../shared/Timer/Timer';
import IubendaCookieSolution from '../../../../utils/iubenda';
import { ga4AddToCart } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxAddToCart } from '../../../shared/lib/farmakomMetrics';
import Link from '../../../shared/Link/Link';
import { Helmet } from 'react-helmet';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';
import {
  getCategoryName,
  getSubcategoryName,
} from '../../../../redux/modules/categories';
import { cleanParagraphReferences } from '../../../shared/lib/descriptionCleaner';

const DescriptionSection = ({ title, description }) => {
  if (description && description.length > 3) {
    return (
      <div className="description-section">
        {!!title && (
          <div
            style={{
              fontSize: '1.25rem',
              fontWeight: 500,
              marginBottom: '0.5rem',
            }}
          >
            {title}
          </div>
        )}
        <div
          dangerouslySetInnerHTML={{
            __html: (cleanParagraphReferences(description) || '')
              .replace(/&nbsp;/g, '')
              .split('<h1>')
              .join(
                '<div style="font-size: 1.5rem; font-weight: 500; margin-bottom: 0.5rem">'
              )
              .split('</h1>')
              .join('</div>')
              .split('<h2>')
              .join(
                '<div style="font-size: 1.4rem; font-weight: 500; margin-bottom: 0.5rem">'
              )
              .split('</h2>')
              .join('</div>')
              .split('<h3>')
              .join(
                '<div style="font-size: 1.3rem; font-weight: 500; margin-bottom: 0.5rem">'
              )
              .split('</h3>')
              .join('</div>')
              .split('<h4>')
              .join(
                '<div style="font-size: 1.2rem; font-weight: 500; margin-bottom: 0.5rem">'
              )
              .split('</h4>')
              .join('</div>')
              .split('<h5>')
              .join(
                '<div style="font-size: 1.1rem; font-weight: 500; margin-bottom: 0.5rem">'
              )
              .split('</h5>')
              .join('</div>')
              .split('<h6>')
              .join(
                '<div style="font-size: 1rem; font-weight: 500; margin-bottom: 0.5rem">'
              )
              .split('</h6>')
              .join('</div>'),
          }}
        />
      </div>
    );
  }

  return null;
};

class DettaglioProdotto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quantity: 1,
      showMore: false,
      showMoreDescription: false,
      peopleLookingNumber: 0,
      currentImage: null,
      isConsentGiven: false,
    };
  }

  async componentDidMount() {
    this.setState({ currentImage: this.props.product.image });
    const peopleLooking = [0, 0, 0, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 5, 5, 6];
    const randomIndex = Math.floor(Math.random() * peopleLooking.length);
    const peopleLookingNumber = peopleLooking[randomIndex];
    this.setState({ peopleLookingNumber });

    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );
    const isConsentGiven = await iubenda.isConsentGiven();
    this.setState({
      isConsentGiven,
    });
    // salvo il primo prodotto su cui atterra l'utente
    this._saveFirstProduct();

    setTimeout(() => {
      this.props.loadPrice();
      this.props.loadBoughtTogether();
      this.props.loadSimilar();
      this.props.loadFreeProducts();
    }, 500);
  }

  componentWillReceiveProps(nextProps) {
    const { maxAddable, quantityInCart } = nextProps;
    const { minNumInCart } = nextProps.product;

    if (quantityInCart !== this.props.quantityInCart) {
      // sto modificando da mini cart
      let newQuantity = this.state.quantity || 1;

      // se ho un minimo devo essere almeno al minimo
      let minInCart = (minNumInCart || 0) - quantityInCart;
      if (newQuantity < minInCart) {
        newQuantity = Math.max(1, minInCart);
      }

      // se ho un massimo devo stare sotto al massimo
      if (newQuantity > maxAddable) {
        newQuantity = maxAddable;
      }

      this.setState({ quantity: newQuantity });
    }
  }

  _saveFirstProduct = () => {
    const firstProductId = sessionStorage.getItem('firstProductId');
    if (!firstProductId || firstProductId === 'undefined') {
      const productId = this.props.product.id;
      if (productId) {
        sessionStorage.setItem('firstProductId', productId);
      }
    }
  };

  readMore = event => {
    event.preventDefault();
    this.setState({
      showMore: true,
    });
  };

  readMoreDescription = event => {
    event.preventDefault();
    this.setState({
      showMoreDescription: true,
    });
  };

  decrement = event => {
    event.preventDefault();
    const { quantityInCart } = this.props;
    const { minNumInCart, maxNumInCart } = this.props.product;

    let minInCart = (minNumInCart || 0) - quantityInCart;

    if (this.state.quantity > minInCart) {
      this.setState({
        quantity: Math.max(this.state.quantity - 1, 1),
      });
    }

    // OLD
    // if (this.state.quantity > 1) {
    // quantity: this.state.quantity - 1,
  };

  increment = event => {
    event.preventDefault();

    const { maxAddable, quantityInCart } = this.props;
    const { minNumInCart } = this.props.product;

    if (this.state.quantity < maxAddable) {
      // Posso aggiungere al carrello
      let newQuantity = this.state.quantity + 1;

      const missingToMinInCart =
        (minNumInCart || 0) - quantityInCart - newQuantity;

      if (missingToMinInCart > 0) {
        newQuantity += missingToMinInCart;
      }

      // OLD
      // if (minNumInCart && (quantityInCart - newQuantity < minNumInCart)) {
      // La nuova quantità che posso aggiungere è il minimo tra
      // la quantità minima carrello meno il numero già in carrello
      // e il numero massimo di pezzi che può essere aggiunto
      // newQuantity = Math.min(minNumInCart - quantityInCart, maxAddable);

      // Applico nuova quantità
      this.setState({
        quantity: newQuantity,
      });
    }
  };

  addToCart = event => {
    const product = this.props.product;

    this.props.addToCart(product, this.state.quantity);

    if (this.props.advancedGa) {
      addToCartEvent({
        id: product.code || '',
        name: product.name,
        category: product.categoryName,
        brand: product.brand,
        price: product.price,
        quantity: this.state.quantity,
      });
    }

    // GA4 ADD TO CART
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4AddToCart({ ...product, quantity: this.state.quantity });
    }

    // FKMX ADD TO CART
    if (this.props.hasFarmakomMetrics) {
      fkmxAddToCart({ ...product, quantity: this.state.quantity });
    }
  };

  renderAvailabilityClass() {
    let { product, sellProductsOutOfStock } = this.props;

    if (
      (sellProductsOutOfStock || product.sellIfOutOfStock) &&
      !product.maxNumInCart
    ) {
      return 'available';
    }

    const minAvailable = product.maxNumInCart
      ? Math.min(product.stock, product.maxNumInCart)
      : product.stock;

    if (minAvailable === 0) {
      return 'not-available';
    } else if (minAvailable > 0 && minAvailable < 10) {
      return 'availability-warning';
    } else {
      return '';
    }
  }

  renderAvailability() {
    let { product, sellProductsOutOfStock } = this.props;
    const isDrugs =
      product.taxCreditType === 'DRUG' ||
      product.taxCreditType === 'HOMEOPATHY';
    const isDrugsVet = product.taxCreditType === 'VETERINARY_DRUG';

    // DATA DISPONIBILITA

    // è presente una data di disponibilità
    if (!!product.availabilityDate) {
      // la data è nel futuro
      if (new Date(product.availabilityDate) > new Date()) {
        return (
          (!!product.sellIfOutOfStock
            ? 'Spedizione dal '
            : 'Disponibile dal ') +
          moment(new Date(product.availabilityDate)).format('DD/MM/YYYY')
        );
      }
    }

    // VENDE FUORI STOCK
    if (sellProductsOutOfStock || !!product.sellIfOutOfStock) {
      return (
        <div>
          <div>{`Disponibile ${product.stock === 0 ? 'in 24 ore' : ''}`}</div>
          {product.maxNumInCart && (
            <div>{`Max ${product.maxNumInCart} pezzi ordinabili`}</div>
          )}
        </div>
      );
    }

    // NON VENDE FUORI STOCK
    if (isDrugs || isDrugsVet) {
      if (product.stock === 0) {
        return 'In riordino';
      }

      // NON VENDE FUORI STOCK E STOCK >= 10
      if (product.maxNumInCart) {
        return `Max ${product.maxNumInCart} pezzi ordinabili`;
      }

      // NON VENDE FUORI STOCK, STOCK >= 10 E NESSUN LIMITE SUI PEZZI ORDINABILI
      return null;
    } else {
      if (product.stock === 0) {
        return 'In riordino';
      } else if (product.stock === 1) {
        return 'Ultimo pezzo disponibile';
      } else if (product.stock < 10) {
        if (product.maxNumInCart && product.maxNumInCart < product.stock) {
          return `Max ${product.maxNumInCart} pezzi ordinabili`;
        }
        return `Ultimi ${product.stock} pezzi disponibili`;
      }

      // NON VENDE FUORI STOCK E STOCK >= 10
      if (product.maxNumInCart) {
        return `Max ${product.maxNumInCart} pezzi ordinabili`;
      }

      // NON VENDE FUORI STOCK, STOCK >= 10 E NESSUN LIMITE SUI PEZZI ORDINABILI
      return null;
    }
  }

  renderMinQuantity() {
    let { product } = this.props;
    if (product.minNumInCart) {
      return (
        <span className="min-quantity">
          {this.renderAvailability() && <br />}Min {product.minNumInCart} pezzi
          ordinabili
        </span>
      );
    }
    return null;
  }

  renderDiscount = (discount, price, listPrice, secondaryColor) => {
    if (discount) {
      return (
        <div
          className="discount discount-highlight"
          style={{
            backgroundColor: secondaryColor,
            color: '#FFF',
          }}
        >
          {discount.toFixed(0)}
          <span>%</span>
        </div>
      );
    } else if (listPrice - price > 0) {
      const discountPercent = ((100 * (listPrice - price)) / listPrice)
        .toFixed(0)
        .replace('.', ',');

      return (
        <div
          className="discount"
          style={{
            backgroundColor: secondaryColor,
            color: '#FFF',
          }}
        >
          {discountPercent}
          <span>%</span>
        </div>
      );
    }

    return null;
  };

  renderSimilarTitle = (categoryName, subcategoryName) => {
    if (!categoryName) {
      return 'Altri prodotti nella stessa categoria';
    }
    if (!!subcategoryName && subcategoryName !== '_') {
      return 'Altri prodotti in ' + categoryName + ' / ' + subcategoryName;
    }
    return 'Altri prodotti in ' + categoryName;
  };

  renderQuantityAddToCart = isMobile => {
    const { primaryColor, maxAddable, isInCart, uiVariantButton } = this.props;
    return (
      <div
        className={`add-to-cart-section ${isMobile ? 'mobile' : 'desktop'}`}
        style={{
          margin: !isMobile ? 0 : null,
        }}
      >
        {maxAddable > 0 && (
          <React.Fragment>
            <CartQuantity
              productName={this.props.product.name}
              value={this.state.quantity}
              onIncrement={this.increment}
              onDecrement={this.decrement}
              primaryColor={primaryColor}
              isBig
              uiVariantButton={uiVariantButton}
            />
            <Button
              className={`btn btn-primary`}
              style={{ color: '#fff' }}
              onClick={this.addToCart}
            >
              <span className="lg-writing">
                {isInCart ? 'Aggiungi un altro' : 'Aggiungi al carrello'}
              </span>
              <span className="xs-writing">Aggiungi</span>
              <Cart />
            </Button>
          </React.Fragment>
        )}
      </div>
    );
  };

  renderQuantityAddToCartFooter = () => {
    const {
      primaryColor,
      maxAddable,
      isInCart,
      facebookAppId,
      uiVariantButton,
    } = this.props;

    return (
      <div
        className={`add-to-cart-section-footer`}
        style={{
          backgroundColor: primaryColor,
        }}
      >
        {maxAddable > 0 && (
          <React.Fragment>
            <CartQuantity
              productName={this.props.product.name}
              value={this.state.quantity}
              onIncrement={this.increment}
              onDecrement={this.decrement}
              primaryColor={primaryColor}
              isInverse
              uiVariantButton={uiVariantButton}
              style={{
                flex: 1,
                marginRight: 0,
                display: 'flex',
                justifyContent: 'center',
              }}
            />
            <Button
              className={`btn btn-inverse`}
              style={{ color: primaryColor, padding: '12px 12px', flex: 1 }}
              onClick={this.addToCart}
            >
              <span className="xs-writing">Aggiungi</span>
              <Cart />
            </Button>
            <div
              style={{
                flex: 1,
                color: 'white',
                fontWeight: 'bold',
                fontSize: 18,
              }}
            >
              <Price
                amount={(this.props.product.price || 0) * this.state.quantity}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  };

  renderQualityOfService = () => {
    const { productDetails } = this.props;
    const showSection =
      productDetails && Object.values(productDetails).some(v => !!v);
    return (
      showSection && (
        <div className={'qualityOfServiceBox'}>
          {productDetails.showSecurePayments && (
            <span className="qualityOfService">
              <PagamentiSicuri
                style={{
                  height: 16,
                  width: 16,
                  stroke: '#2857ed',
                  fill: 'white',
                  strokeWidth: 2,
                }}
              />
              <span className="quality-text">Pagamenti sicuri SSL</span>
            </span>
          )}
          {productDetails.showEasyReturns && (
            <span className="qualityOfService">
              <Resi
                style={{
                  height: 16,
                  width: 16,
                  stroke: '#2857ed',
                  fill: 'white',
                  strokeWidth: 2,
                }}
              />
              <span className="quality-text">Resi facili e veloci</span>
            </span>
          )}
          {productDetails.showOnlyAuthorizedPharmacies && (
            <span className="qualityOfService">
              <Autorizzate
                style={{
                  height: 16,
                  width: 16,
                  stroke: '#2857ed',
                  fill: 'white',
                  strokeWidth: 2,
                }}
              />
              <span className="quality-text">Solo Farmacie autorizzate</span>
            </span>
          )}
          {productDetails.showShippingIn &&
            this.props.shippingTime &&
            this.props.shippingTime.length > 0 && (
              <span className="qualityOfService">
                <Consegne
                  style={{
                    height: 16,
                    width: 16,
                    stroke: '#2857ed',
                    fill: 'white',
                    strokeWidth: 2,
                  }}
                />
                <span className="quality-text">{this.props.shippingTime}</span>
              </span>
            )}
        </div>
      )
    );
  };

  addZero = int => {
    return int <= 9 ? `0${int}` : `${int}`;
  };

  renderMonth = month => {
    const months = [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre',
    ];
    return months[month];
  };

  renderShippingDay = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    if (this.props.hasBrtFastShipping) {
      tomorrow.setDate(tomorrow.getDate() + 1);
    } else {
      tomorrow.setDate(tomorrow.getDate() + 2);
    }
    const now = new Date().setUTCHours(
      new Date().getUTCHours() - new Date().getTimezoneOffset() / 60
    );
    const hour = new Date(now).getUTCHours();
    const day = new Date(now).getDay();
    if (this.props.hasBrtFastShipping) {
      if (day === 5) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Lunedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else if (day === 6 || day === 0) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Mercoledì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else {
        if (hour < 18) {
          return (
            <span>
              Ricevilo <b className={'shipping-day'}>Domani</b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo <b className={'shipping-day'}>Dopodomani</b>
            </span>
          );
        }
      }
    } else {
      //non ha la spedizione bartolini in un giorno
      //ordine di venerdì
      if (day === 5 || day === 4) {
        if (hour < 18) {
          return (
            //arrivo lunedì
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Lunedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            //arrivo martedì
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else if (day === 6) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Martedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Mercoledì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else if (day === 0) {
        if (hour < 18) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Mercoledì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Giovedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      } else {
        if (hour < 18) {
          return (
            <span>
              Ricevilo <b className={'shipping-day'}>Dopodomani</b>
            </span>
          );
        } else if (day === 1) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Giovedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else if (day === 2) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Venerdì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        } else if (day === 3) {
          return (
            <span>
              Ricevilo{' '}
              <b className={'shipping-day'}>
                Lunedì {this.addZero(tomorrow.getDate())}
              </b>
            </span>
          );
        }
      }
    }
  };

  renderFastShippingCountdown = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const now = new Date().setUTCHours(
      new Date().getUTCHours() - new Date().getTimezoneOffset() / 60
    );
    const hour = new Date(now).getUTCHours();

    if (hour < 18) {
      today.setHours(18);
      today.setMinutes(0);
      today.setSeconds(0);

      return <Timer dateEnd={today} color={'#f77878'} />;
    } else {
      tomorrow.setHours(18);
      tomorrow.setMinutes(0);
      tomorrow.setSeconds(0);
      return <Timer dateEnd={tomorrow} />;
    }
  };

  renderShippingTime = () => {
    return (
      <div style={{ margin: '30px 0' }}>
        {this.props.freeShippingThreshold &&
          this.props.freeShippingThreshold > 0 &&
          this.props.product.shippingCategory === 1 && (
            <div
              style={{
                fontSize: 12,
                color: this.props.primaryColor,
                fontWeight: 600,
                textTransform: 'uppercase',
                marginBottom: 2,
              }}
            >
              Spedizione gratuita da € {this.props.freeShippingThreshold}
            </div>
          )}
        {this.props.freeShippingThreshold &&
          this.props.freeShippingThreshold > 0 &&
          !!this.props.product.shippingCategory &&
          this.props.product.shippingCategory !== 1 && (
            <div
              style={{
                fontSize: 12,
                color: this.props.primaryColor,
                fontWeight: 600,
                textTransform: 'uppercase',
                marginBottom: 2,
              }}
            >
              {this.props.glsShipping[
                'priceCategory' + this.props.product.shippingCategory
              ] === 0
                ? 'Aggiungendo questo prodotto le spese di spedizione diventano gratuite'
                : `Aggiungendo questo prodotto la spedizione costerà € ${this
                  .props.glsShipping[
                'priceCategory' + this.props.product.shippingCategory
                ] &&
                this.props.glsShipping[
                  'priceCategory' + this.props.product.shippingCategory
                ].toFixed(2)}`}
            </div>
          )}
        {this.props.showTimer && (
          <div style={{ fontSize: 11 }}>
            {this.renderShippingDay()} se ordini entro:{' '}
            <span style={{ color: 'red' }}>
              {' '}
              {this.renderFastShippingCountdown()}
            </span>
          </div>
        )}
      </div>
    );
  };

  renderBoughtTogether = primaryColor => {
    const { product, isMobile } = this.props;
    const ga4ListInfo = {
      id: `bought_together_${product.seoName}`,
      name: `Bought Together > ${product.seoName}`,
    };
    const productsConfiguration = this.props.homePageConfiguration.find(
      item => {
        if (item.moduleType === 'Products_carousel') {
          return item;
        }
        return;
      }
    );

    return (
      <div>
        {!isMobile && (
          <div class="desktop">
            <ItemSlider
              title="Spesso comprati insieme"
              primaryColor={this.props.primaryColor}
              secondaryColor={this.props.secondaryColor}
              uiVariant={this.props.uiVariantThumbnail}
              productsCarouselVersion={2}
              productsThumbnail={this.props.productsThumbnail}
            >
              {this.props.product.boughtTogether.map(product => {
                return (
                  <div className="mobile-thumbnail">
                    <ProductThumbnail
                      primaryColor={primaryColor}
                      secondaryColor={this.props.secondaryColor}
                      productsCarouselVersion={
                        productsConfiguration.moduleVersion
                      }
                      productsThumbnail={this.props.productsThumbnail}
                      key={product.id}
                      product={product}
                      list="Bought together slider"
                      ga4ListInfo={ga4ListInfo}
                    />
                  </div>
                );
              })}
            </ItemSlider>
          </div>
        )}
        {!!isMobile && (
          <div class="mobile">
            <div
              style={{
                display: 'flex',
                overflowX: 'scroll',
                gap: 8,
                maxWidth: '100vw',
                paddingRight: 24,
              }}
            >
              {this.props.product.boughtTogether.map(product => {
                return (
                  <div className="mobile-thumbnail">
                    <ProductThumbnail
                      primaryColor={primaryColor}
                      secondaryColor={this.props.secondaryColor}
                      productsCarouselVersion={
                        productsConfiguration.moduleVersion
                      }
                      productsThumbnail={this.props.productsThumbnail}
                      key={product.id}
                      product={product}
                      list="Bought together slider"
                      ga4ListInfo={ga4ListInfo}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderSameCategory = primaryColor => {
    const { product, isMobile } = this.props;
    const ga4ListInfo = {
      id: `similar_products_${product.seoName}`,
      name: `Similar Products > ${product.seoName}`,
    };
    const productsConfiguration = this.props.homePageConfiguration.find(
      item => {
        if (item.moduleType === 'Products_carousel') {
          return item;
        }
        return;
      }
    );

    return (
      <div>
        {!isMobile && (
          <div className="desktop">
            <ItemSlider
              title={this.renderSimilarTitle(
                this.props.categoryName,
                this.props.subcategoryName
              )}
              primaryColor={this.props.primaryColor}
              secondaryColor={this.props.secondaryColor}
              uiVariant={this.props.uiVariantThumbnail}
              productsCarouselVersion={2}
              productsThumbnail={this.props.productsThumbnail}
            >
              {this.props.product.similar.map(product => {
                return (
                  <div className="mobile-thumbnail">
                    <ProductThumbnail
                      primaryColor={primaryColor}
                      secondaryColor={this.props.secondaryColor}
                      productsCarouselVersion={
                        productsConfiguration.moduleVersion
                      }
                      productsThumbnail={this.props.productsThumbnail}
                      key={product.id}
                      product={product}
                      list="Similar products slider"
                      ga4ListInfo={ga4ListInfo}
                    />
                  </div>
                );
              })}
            </ItemSlider>
          </div>
        )}
        {!!isMobile && (
          <div className="mobile">
            <div
              style={{
                display: 'flex',
                overflowX: 'scroll',
                gap: 8,
                maxWidth: '100vw',
                paddingRight: 24,
              }}
            >
              {this.props.product.similar.map(product => {
                return (
                  <div className="mobile-thumbnail">
                    <ProductThumbnail
                      primaryColor={primaryColor}
                      secondaryColor={this.props.secondaryColor}
                      productsCarouselVersion={
                        productsConfiguration.moduleVersion
                      }
                      productsThumbnail={this.props.productsThumbnail}
                      key={product.id}
                      product={product}
                      list="Similar products slider"
                      ga4ListInfo={ga4ListInfo}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderSlogan = (data, primaryColor) => {
    return (
      <div className="slogan-container">
        <div className="title" style={{ color: primaryColor }}>
          {data.sloganTitle}
        </div>
        <div className="subtitle-slogan">{data.sloganSubtitle}</div>
        {!!data.sloganText1 && (
          <div className="text">
            <div className="tick-container">
              <Tick style={{ fill: primaryColor }} />
            </div>
            <div classname="txt">{data.sloganText1}</div>
          </div>
        )}
        {!!data.sloganText2 && (
          <div className="text">
            <div className="tick-container">
              <Tick style={{ fill: primaryColor }} />
            </div>
            <div classname="txt">{data.sloganText2}</div>
          </div>
        )}
        {!!data.sloganText3 && (
          <div className="text">
            <div className="tick-container">
              <Tick style={{ fill: primaryColor }} />
            </div>
            <div classname="txt">{data.sloganText3}</div>
          </div>
        )}
      </div>
    );
  };

  renderDescriptionAdditional = data => {
    return (
      <div className="description-additional-container">
        <div className="title">{data.descriptionAdditionalTitle}</div>
        <div className="subtitle">{data.descriptionAdditionalSubtitle}</div>
      </div>
    );
  };

  renderAddToCartButton = isMobile => {
    const { primaryColor, isInCart, maxAddable, uiVariantButton } = this.props;
    return (
      <div className="addToCart">
        <div
          className={`add-to-cart-section ${isMobile ? 'desktop' : 'desktop'}`}
          style={{
            backgroundColor: isMobile ? 'transparent' : 'transparent',
            margin: !isMobile ? 0 : null,
          }}
        >
          {maxAddable > 0 && (
            <React.Fragment>
              <Button
                className={`btn ${isMobile ? 'btn-inverse' : 'btn-primary'}`}
                style={{ color: isMobile ? primaryColor : '#fff' }}
                onClick={this.addToCart}
              >
                <span className="lg-writing">
                  {isInCart ? 'Aggiungi un altro' : 'Aggiungi al carrello'}
                </span>
                <span className="xs-writing">Aggiungi</span>
                <Cart />
              </Button>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  };

  renderBanner = data => {
    return (
      <div className="banner-container-box">
        <div className="banner-container">
          <ImageDispatcher
            src={data.banner}
            alt="Immagine Banner"
            className="banner"
          />
        </div>
      </div>
    );
  };

  validateURL = textval => {
    let urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
    return urlregex.test(textval);
  };

  renderMediaDescription = data => {
    return (
      <div className="media-description-container">
        {/*//react-player component*/}
        <div className="media-presentation-container">
          {data.mediaPresentationVideo ? (
            this.state.isConsentGiven ? (
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                src={data.mediaPresentationVideo}
              ></iframe>
            ) : null
          ) : (
            <ImageDispatcher
              src={data.mediaPresentation}
              alt="Immagine di presentazione media"
            />
          )}
        </div>
        <div className="infobox">
          <div className="title">{data.mediaDescriptionTitle}</div>
          <div className="subtitle">{data.mediaDescriptionSubtitle}</div>
        </div>
      </div>
    );
  };

  renderBeneficialEffects = (data, primaryColor) => {
    return (
      <div className="beneficial-effects-container">
        <div className="header">
          <div className="title">{data.beneficialEffectTitle}</div>
          <div className="subtitle">{data.beneficialEffectSubtitle}</div>
        </div>
        {!!data.icon1 && (
          <div className="icon-description-container">
            <div className="icon" style={{ backgroundColor: primaryColor }}>
              <ImageDispatcher src={data.icon1} alt="Icona 1" />
            </div>
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: data.iconDescription1 }}
            />
          </div>
        )}
        {!!data.icon2 && (
          <div className="icon-description-container">
            <div className="icon" style={{ backgroundColor: primaryColor }}>
              <ImageDispatcher src={data.icon2} alt="" />
            </div>
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: data.iconDescription2 }}
            />
          </div>
        )}
        {!!data.icon2 && (
          <div className="icon-description-container">
            <div className="icon" style={{ backgroundColor: primaryColor }}>
              <ImageDispatcher src={data.icon3} alt="" />
            </div>
            <div
              className="text"
              dangerouslySetInnerHTML={{ __html: data.iconDescription3 }}
            />
          </div>
        )}
      </div>
    );
  };

  renderAdditionalInformation = (data, primaryColor, secondaryColor) => {
    return (
      <div className="additional-info-container">
        <div className="container">
          <div className="img">
            <ImageDispatcher
              className="product-image"
              src={this.state.currentImage}
              alt={`${this.state.currentImage}`}
            />
          </div>
          <div className="info-container">
            {data.additionalInfo1 != null && data.additionalInfo1 !== '' && (
              <div className="single-info">
                <Tick
                  style={{ fill: 'white', backgroundColor: primaryColor }}
                />
                <div className="text">{data.additionalInfo1}</div>
              </div>
            )}
            {data.additionalInfo2 != null && data.additionalInfo2 !== '' && (
              <div className="single-info">
                <Tick
                  style={{ fill: 'white', backgroundColor: primaryColor }}
                />
                <div className="text">{data.additionalInfo2}</div>
              </div>
            )}
            {data.additionalInfo3 != null && data.additionalInfo3 !== '' && (
              <div className="single-info">
                <Tick
                  style={{ fill: 'white', backgroundColor: primaryColor }}
                />
                <div className="text">{data.additionalInfo3}</div>
              </div>
            )}
            {data.additionalInfo4 != null && data.additionalInfo4 !== '' && (
              <div className="single-info">
                <Tick
                  style={{ fill: 'white', backgroundColor: primaryColor }}
                />
                <div className="text">{data.additionalInfo4}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderImageSelector = (data, siteName) => {
    const additionalImages = [data.image2, data.image3, data.image4];
    const anyAdditionalImage = additionalImages.some(image => !!image);
    return (
      !!anyAdditionalImage && (
        <div className="image-mini-container">
          {!!data.image && (
            <div
              className="image-mini"
              onClick={() => this.setState({ currentImage: data.image })}
            >
              <ImageDispatcher
                className="product-image"
                src={data.image}
                alt={`${data.name} - ${siteName}`}
              />
            </div>
          )}
          {!!data.image2 && (
            <div
              className="image-mini"
              onClick={() => this.setState({ currentImage: data.image2 })}
            >
              <ImageDispatcher
                className="product-image"
                src={data.image2}
                alt={`${data.name} - ${siteName}`}
              />
            </div>
          )}
          {!!data.image3 && (
            <div
              className="image-mini"
              onClick={() => this.setState({ currentImage: data.image3 })}
            >
              <ImageDispatcher
                className="product-image"
                src={data.image3}
                alt={`${data.name} - ${siteName}`}
              />
            </div>
          )}
          {!!data.image4 && (
            <div
              className="image-mini"
              onClick={() => this.setState({ currentImage: data.image4 })}
            >
              <ImageDispatcher
                className="product-image"
                src={data.image4}
                alt={`${data.name} - ${siteName}`}
              />
            </div>
          )}
        </div>
      )
    );
  };

  // Gestione omaggi
  renderGift = () => {
    const { product } = this.props;

    return (
      <div style={{ marginTop: 16 }}>
        {product.freeProducts.map(promotion => {
          const promotionType = promotion.productId
            ? 'product'
            : promotion.brandId
              ? 'brand'
              : promotion.tagId
                ? 'tag'
                : promotion.categoryId
                  ? 'category'
                  : 'all';

          let promotionLink = '';
          if (promotionType === 'brand') {
            promotionLink = '/brand/' + promotion.brandSeoName;
          } else if (promotionType === 'tag') {
            promotionLink = '/tag/' + promotion.tagSeoName;
          } else if (promotionType === 'category') {
            promotionLink =
              '/prodotti/' +
              promotion.parentCategorySeoName +
              '/' +
              promotion.categorySeoName;
          } else if (promotionType === 'all') {
            promotionLink = '/prodotti-in-offerta';
          }

          return (
            <div className="gift">
              <div>
                <h3>{promotion.name}</h3>
                {promotionType === 'product' ? (
                  <div>
                    Aggiungendo più pezzi di questo prodottt al carrello
                    riceverai in omaggio:
                  </div>
                ) : (
                  <div>
                    Aggiungendo più pezzi di questa{' '}
                    <Link to={promotionLink}>promozione</Link> riceverai in
                    omaggio:
                  </div>
                )}
              </div>
              <div className="description">
                <div style={{ marginTop: 24 }} key={promotion.id}>
                  {promotion.ranges
                    .sort((a, b) => a.quantityFrom - b.quantityFrom)
                    .map(range => (
                      <div style={{ marginTop: 16 }}>
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 16,
                            marginTop: 8,
                          }}
                        >
                          <FreeProductCard
                            key={range.id}
                            range={range}
                            background={this.props.primaryColor}
                          />
                        </div>
                        <div style={{ marginTop: 8, fontSize: 12 }}>
                          * offerta valida con l'acquisto da{' '}
                          {range.quantityFrom} a {range.quantityTo} prodotti
                          della{' '}
                          {promotionType === 'product' ? (
                            'promozione'
                          ) : (
                            <Link to={promotionLink}>promozione</Link>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const {
      product,
      category,
      subcategory,
      siteName,
      siteUrl,
      sellProductsOutOfStock,
      hideOmnibusInfo,
      primaryColor,
      secondaryColor,
      linkDrugsAuthorizedSite,
      linkDrugsAuthorizedSiteVet,
      uiVariantButton,
    } = this.props;

    const isDrugs =
      product.taxCreditType === 'DRUG' ||
      product.taxCreditType === 'HOMEOPATHY';
    const isDrugsVet = product.taxCreditType === 'VETERINARY_DRUG';

    return (
      <div>
        <Helmet>
          <script type="application/ld+json">{`
            {
              "@context": "https://schema.org/",
              "@type": "Product",
              "sku": "${product.id}",
              "image": "${product.image}",
              "name": "${capitalize(product.name)}",
              "description": "${cleanHtml(product.description)}",
              ${!!product.ean && checkEanValidity(product.ean)
              ? `"gtin": "${product.ean}",`
              : ''
            }
              "brand": {
                "@type": "Brand",
                "name": "${product.brand}"
              },
              "offers": {
                "@type": "Offer",
                "url": "${siteUrl}/${product.categorySeoName}/${product.subcategorySeoName
            }/${product.seoName}",
                "itemCondition": "https://schema.org/NewCondition",
                "availability": "https://schema.org/${product.stock > 0 ||
              !!product.sellIfOutOfStock ||
              !!sellProductsOutOfStock
              ? 'InStock'
              : 'OutOfStock'
            }",
                "price": "${product.price}",
                "priceCurrency": "EUR"
              }
            }
          `}</script>
        </Helmet>
        <div className="container">
          <div
            className={`dettaglio-prodotto ${product.specialOffer ? 'special-offer' : ''
              } ${this.renderAvailabilityClass()}`}
          >
            <div className="product-details">
              <div className="row">
                <div className="col-md-4">
                  <div
                    className="image-box"
                    style={{
                      borderRadius:
                        uiVariantButton === '1'
                          ? '12px'
                          : uiVariantButton === '3'
                            ? '6px'
                            : 0,
                    }}
                  >
                    <ImageDispatcher
                      className="product-image"
                      src={this.state.currentImage || product.image}
                      alt={
                        product.imageAltText || `${product.name} - ${siteName}`
                      }
                    />
                    {this.renderDiscount(
                      product.discount,
                      product.price,
                      product.listPrice,
                      secondaryColor
                    )}
                  </div>
                  {!!this.props.textBelowProductImage && (
                    <div
                      style={{
                        padding: '1rem 0',
                        fontSize: 10,
                        textAlign: 'center',
                      }}
                    >
                      {this.props.textBelowProductImage}
                    </div>
                  )}
                  {(!!product.urlProductInfo || !!product.urlCertification) && (
                    <div className="certification-container">
                      {!!product.urlProductInfo && (
                        <a
                          href={product.urlProductInfo}
                          target="_blank"
                          className="certification-item"
                        >
                          <FaFilePdf color={primaryColor} />
                          <span className="certification-text">
                            SCARICA LA SCHEDA
                          </span>
                        </a>
                      )}
                      {!!product.urlCertification && (
                        <a
                          href={product.urlProductInfo}
                          target="_blank"
                          className="certification-item"
                        >
                          <FaFilePdf color={primaryColor} />
                          <span className="certification-text">
                            SCARICA IL CERTIFICATO
                          </span>
                        </a>
                      )}
                    </div>
                  )}
                  {this.renderImageSelector(product, siteName)}
                  {/* RECENSIONI FEEDATY */}
                  {!!this.props.feedaty.enabled && (
                    <div
                      class="feedaty_widget"
                      data-type="product"
                      data-variant="Striscia-slim"
                      data-id={`selettore${product.id}`}
                      data-gui="all"
                      data-lang="all"
                      data-sku={product.id}
                    ></div>
                  )}
                </div>

                <div className="col-md-8">
                  <nav>
                    {!this.props.isMobile && (
                      <Breadcrumb
                        page={product.type}
                        category={category}
                        subcategory={subcategory}
                        product={product}
                      />
                    )}
                    {!!this.props.isMobile &&
                      !!product.type &&
                      !!product.type !== 'undefined' &&
                      [category, subcategory].some(
                        i => !!i && i !== 'undefined'
                      ) && (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          {!!category && category !== 'undefined' ? (
                            <Link
                              to={`/${product.type}/${category}`}
                              aria-label={`Guarda tutti i prodotti della categoria "${this.props.categoryName}"`}
                            >
                              {this.props.categoryName}
                            </Link>
                          ) : (
                            <div>{this.props.categoryName}</div>
                          )}
                          {[category, subcategory].every(
                            i => !!i && i !== 'undefined'
                          ) ? (
                            <Link
                              to={`/${product.type}/${category}/${subcategory}`}
                              aria-label={`Guarda tutti i prodotti della categoria "${this.props.subcategoryName}"`}
                            >
                              {this.props.subcategoryName}
                            </Link>
                          ) : (
                            <div>{this.props.subcategoryName}</div>
                          )}
                        </div>
                      )}
                  </nav>

                  <h1>{product.name}</h1>
                  <hr style={{ width: '100%' }} />
                  <div
                    className="subtitle"
                    style={{ color: primary_s5_l70(primaryColor) }}
                  >
                    <div style={{ display: 'flex' }}>
                      <h2>Marca: </h2>
                      <span className="subtitle-data"> {product.brand}</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                      <h2>AIC: </h2>
                      <span className="subtitle-data"> {product.code}</span>
                    </div>
                    {product.ean && (
                      <div style={{ display: 'flex' }}>
                        {' '}
                        <h2>EAN: </h2>
                        <span className="subtitle-data"> {product.ean}</span>
                      </div>
                    )}
                  </div>
                  <hr style={{ width: '100%' }} />

                  {!!product.prescription && (
                    <div className="prescription-detail">
                      <ImageDispatcher
                        src="/static/images/icona-ricetta.svg"
                        style={{ height: 32, width: 32, marginRight: 24 }}
                      />
                      <div>QUESTO FARMACO PREVEDE LA RICETTA</div>
                    </div>
                  )}

                  {product.sloganTitle != null &&
                    this.renderSlogan(product, primaryColor)}

                  <div className="price-availability">
                    {!!this.renderAvailability() && (
                      <div className="availability">
                        {this.renderAvailability()}
                        {this.renderMinQuantity()}
                      </div>
                    )}

                    <div>
                      <div className="price-container">
                        <div
                          className={`prev-price ${product.listPrice &&
                            product.listPrice > product.price
                            ? ''
                            : 'hidden'
                            }`}
                        >
                          <Price amount={product.listPrice} />
                        </div>
                        <div className="price">
                          <Price amount={product.price} />
                        </div>
                      </div>
                    </div>

                    {product.listPrice > product.price ? (
                      <div className="saving">
                        Risparmio{' '}
                        <Price amount={product.listPrice - product.price} />
                      </div>
                    ) : (
                      <div>&nbsp;</div>
                    )}
                  </div>
                  {!!product.lowestPriceLast30Days && !hideOmnibusInfo && (
                    <div className="lowest-price">
                      Prezzo più basso praticato nei 30 giorni:
                      <s>
                        <Price amount={product.lowestPriceLast30Days} />
                      </s>
                    </div>
                  )}

                  {this.renderQuantityAddToCart(this.props.isMobile)}

                  {this.renderQuantityAddToCartFooter()}

                  {product.expirationDate && (
                    <div
                      style={{
                        margin: '30px 0',
                        fontSize: '12px',
                        color: 'rgb(247, 120, 120)',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                      }}
                    >{`Scadenza: ${product.expirationDate}`}</div>
                  )}
                  {this.renderShippingTime()}
                  {this.renderQualityOfService()}

                  <div style={{ marginTop: 30 }}>
                    <MessaggioChiusura type="cart" />
                  </div>
                </div>
              </div>
            </div>

            {!!product.freeProducts.length && this.renderGift()}

            {(product.description ||
              product.designation ||
              product.activeIngredients ||
              product.excipients ||
              product.drugInformations ||
              product.contraindications ||
              product.dosage ||
              product.storage ||
              product.warnings ||
              product.interactions ||
              product.sideEffects ||
              product.overdose ||
              product.pregnancyBreastfeeding ||
              (product.type && product.type.toLowerCase() === 'farmaci')) && (
                <div
                  className="product-description"
                  style={{
                    borderRadius:
                      uiVariantButton === '1'
                        ? '12px'
                        : uiVariantButton === '3'
                          ? '6px'
                          : 0,
                  }}
                >
                  {isDrugs && !!linkDrugsAuthorizedSite && (
                    <div className="authorized-site">
                      <A
                        className="store-authorized-link"
                        href={linkDrugsAuthorizedSite}
                        target="_blank"
                        aria-label="Link all'autorizzazione ministeriale della farmacia"
                      >
                        <ImageDispatcher
                          src="/static/images/logo_farmacia_autorizzata.png"
                          alt="Logo farmacia autorizzata"
                        />
                      </A>
                    </div>
                  )}
                  {isDrugsVet && !!linkDrugsAuthorizedSiteVet && (
                    <div className="authorized-site">
                      <A
                        className="store-authorized-link"
                        href={linkDrugsAuthorizedSiteVet}
                        target="_blank"
                        aria-label="Link all'autorizzazione ministeriale della farmacia"
                      >
                        <ImageDispatcher
                          src="/static/images/logo_farmacia_autorizzata_vet.png"
                          alt="Logo farmacia autorizzata"
                        />
                      </A>
                    </div>
                  )}

                  {product.description && (
                    <div>
                      <div
                        className={`description ${this.state
                          .showMoreDescription && 'open'}`}
                      >
                        <DescriptionSection
                          title="Dettagli Prodotto"
                          description={product.description}
                        />
                      </div>
                      {!this.state.showMoreDescription &&
                        product.description.length > 400 && (
                          <div className="read-more">
                            <div
                              className="read-more-button"
                              aria-label="Leggi di più"
                              onClick={this.readMoreDescription}
                            >
                              Leggi di più <FiChevronDown />
                            </div>
                          </div>
                        )}
                    </div>
                  )}

                  <DescriptionSection
                    title="Denominazione"
                    description={product.designation}
                  />
                  <DescriptionSection
                    title="Principi attivi"
                    description={product.activeIngredients}
                  />
                  <DescriptionSection
                    title="Eccipienti"
                    description={product.excipients}
                  />
                  <DescriptionSection
                    title="Indicazioni terapeutiche"
                    description={product.drugInformations}
                  />

                  {(product.contraindications ||
                    product.dosage ||
                    product.storage ||
                    product.warnings ||
                    product.interactions ||
                    product.sideEffects ||
                    product.overdose ||
                    product.pregnancyBreastfeeding) && (
                      <div>
                        {!this.state.showMore && (
                          <div className="read-more">
                            <A href="#" onClick={this.readMore}>
                              Leggi di più <FiChevronDown />
                            </A>
                          </div>
                        )}

                        {this.state.showMore && (
                          <div className="read-more-content">
                            <DescriptionSection
                              title="Controindicazioni/Effetti collaterali"
                              description={product.contraindications}
                            />
                            <DescriptionSection
                              title="Posologia"
                              description={product.dosage}
                            />
                            <DescriptionSection
                              title="Conservazione"
                              description={product.storage}
                            />
                            <DescriptionSection
                              title="Avvertenze"
                              description={product.warnings}
                            />
                            <DescriptionSection
                              title="Interazioni"
                              description={product.interactions}
                            />
                            <DescriptionSection
                              title="Effetti indesiderati"
                              description={product.sideEffects}
                            />
                            <DescriptionSection
                              title="Sovradosaggi"
                              description={product.overdose}
                            />
                            <DescriptionSection
                              title="Gravidanza e allattamento"
                              description={product.pregnancyBreastfeeding}
                            />
                          </div>
                        )}
                      </div>
                    )}
                </div>
              )}

            {!!product.descriptionAdditionalTitle &&
              this.renderDescriptionAdditional(product)}
            {!!product.mediaDescriptionTitle &&
              this.renderMediaDescription(product)}
            {!!product.mediaDescriptionTitle &&
              this.renderAddToCartButton(false, primaryColor)}
            {!!product.banner && this.renderBanner(product)}
            {!!product.beneficialEffectTitle &&
              this.renderBeneficialEffects(product, primaryColor)}
          </div>
        </div>

        {!!product.additionalInfo1 &&
          this.renderAdditionalInformation(
            product,
            primaryColor,
            secondaryColor
          )}

        <div className="container">
          {product.boughtTogether && product.boughtTogether.length > 0 && (
            <section>
              {product.description ||
                product.designation ||
                product.activeIngredients ||
                product.excipients ||
                product.drugInformations ||
                product.contraindications ||
                product.dosage ||
                product.storage ||
                product.warnings ||
                product.interactions ||
                product.sideEffects ||
                product.overdose ||
                product.pregnancyBreastfeeding ||
                (product.type && product.type.toLowerCase() === 'farmaci') ? (
                <>
                  <h4
                    style={{
                      fontSize: '1.5rem',
                      marginTop: '2rem',
                      marginBottom: '1rem',
                    }}
                  >
                    Spesso comprati insieme
                  </h4>
                  {this.renderBoughtTogether()}
                </>
              ) : (
                <>
                  <h3
                    style={{
                      fontSize: '1.5rem',
                      marginTop: '2rem',
                      marginBottom: '1rem',
                    }}
                  >
                    Spesso comprati insieme
                  </h3>
                  {this.renderBoughtTogether()}
                </>
              )}
            </section>
          )}

          {product.similar && product.similar.length > 0 && (
            <section style={{ marginBottom: '4rem' }}>
              {product.description ||
                product.designation ||
                product.activeIngredients ||
                product.excipients ||
                product.drugInformations ||
                product.contraindications ||
                product.dosage ||
                product.storage ||
                product.warnings ||
                product.interactions ||
                product.sideEffects ||
                product.overdose ||
                product.pregnancyBreastfeeding ||
                (product.type && product.type.toLowerCase() === 'farmaci') ? (
                <>
                  <h4
                    style={{
                      fontSize: '1.5rem',
                      marginTop: '2rem',
                      marginBottom: '1rem',
                    }}
                  >
                    Nella stessa categoria
                  </h4>
                  {this.renderSameCategory()}
                </>
              ) : (
                <>
                  <h3
                    style={{
                      fontSize: '1.5rem',
                      marginTop: '2rem',
                      marginBottom: '1rem',
                    }}
                  >
                    Nella stessa categoria
                  </h3>
                  {this.renderSameCategory()}
                </>
              )}
            </section>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.layout.isMobile,

    categoryName: getCategoryName(state, ownProps.category),
    subcategoryName: getSubcategoryName(state, ownProps.subcategory),

    isInCart: isInCart(state, ownProps.product && ownProps.product.id),
    maxAddable: getMaxAddable(state, ownProps.product),
    quantityInCart: quantityInCart(
      state,
      ownProps.product && ownProps.product.id
    ),
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    sellProductsOutOfStock:
      state.store.data.funzionalita.sellProductsOutOfStock,
    hideOmnibusInfo: state.store.data.funzionalita.hideOmnibusInfo,
    facebookAppId: state.store.data.integrazioni.facebook.appId,
    advancedGa: state.store.data.features.advancedGa,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    uiVariantThumbnail: state.store.data.uiVariants.thumbnail,
    uiVariantButton: state.store.data.uiVariants.buttons,
    freeShippingThreshold:
      state.store.data.costiSpedizione.freeShippingThreshold,
    showTimer: state.store.data.loghiTemplate.productThumbnail.shippingTimer,
    shippingTime: state.store.data.home.shippingDescription,
    hasBrtFastShipping: state.store.data.features.hasBrtFastShipping,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    glsShipping: state.store.data.glsShipping,
    homePageConfiguration: state.store.data.home.homePageConfiguration,
    productsThumbnail: state.store.data.home.visualVariants.thumbnailProduct,
    productDetails: state.store.data.funzionalita.productDetails,
    textBelowProductImage: state.store.data.loghiTemplate.textBelowProductImage,
    feedaty: {
      enabled: state.store.data.features.hasFeedaty,
      merchantCode: state.store.data.integrazioni.feedaty.merchantCode,
      widgetId: state.store.data.integrazioni.feedaty.widgetId,
      siteKey: state.store.data.integrazioni.feedaty.siteKey,
    },
  };
}

export default withRouter(
  connect(mapStateToProps, {
    addToCart,
    loadPrice,
    loadBoughtTogether,
    loadSimilar,
    loadFreeProducts,
  })(DettaglioProdotto)
);

const cleanHtml = string =>
  !!string
    ? string
      .replace(/<\/?[^>]+(>|$)/g, '')
      .split('"')
      .join('')
    : '';

const capitalize = string => {
  if (!string) return '';
  return string
    .trim()
    .split(' ')
    .map(s => (s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : null))
    .filter(s => s)
    .join(' ');
};

const checkEanValidity = barcode => {
  if (!barcode) return false;

  let barcodeLengthArr = [8, 12, 13, 14];
  let allowedChars = new RegExp(/\d{8,14}/); // >7 & <15

  // put numbers in array and convert to type Int.
  let barcodeArray = barcode.split('');
  for (let i = 0; i < barcodeArray.length; i++) {
    barcodeArray[i] = parseInt(barcodeArray[i], 10);
  }

  // get the last digit for checking later
  let checkDigit = barcodeArray.slice(-1)[0];

  // we'll need a to compare it to this:
  let remainder = 0;

  // check if input (barcode) is in the array and check against the regex.
  if (
    barcodeLengthArr.find(val => val === barcode.length) &&
    allowedChars.test(barcode)
  ) {
    // Pop the last item from the barcode array, test if the length is
    // odd or even (see note on calculating the check digit) and
    // multiply each item in array based in position:
    let total = 0;
    barcodeArray.pop();

    // odd length after pop
    if (barcodeArray.length % 2 === 1) {
      for (let i = barcodeArray.length - 1; i >= 0; i--) {
        barcodeArray[i] =
          i % 2 === 0 ? barcodeArray[i] * 3 : barcodeArray[i] * 1;
        total += barcodeArray[i];
      }
      // even length after pop
    } else if (barcodeArray.length % 2 === 0) {
      for (let i = barcodeArray.length - 1; i >= 0; i--) {
        barcodeArray[i] =
          i % 2 === 0 ? barcodeArray[i] * 1 : barcodeArray[i] * 3;
        total += barcodeArray[i];
      }
    } else {
      // validation passed = false
      return false;
    }

    // calculate the remainder of totalrounded up to nearest multiple of 10:
    remainder = Math.ceil((total + 1) / 10) * 10 - total;

    if (remainder === checkDigit) {
      //validation passed = true;
      return true;
    } else {
      //validation passed = false;
      return false;
    }
  } else {
    //validation Passed = false;
    return false;
  }
};

const FreeProductCard = ({ range, background }) => {
  return (
    <Link
      to={`/${range.type}/${range.categoryParentSeoName}/${range.categorySeoName}/${range.seoName}`}
      style={{ position: 'relative', width: 'fit-content', cursor: 'pointer' }}
    >
      <div
        style={{
          position: 'absolute',
          background,
          width: 32,
          height: 32,
          borderRadius: '50%',
          top: -16,
          right: -16,
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <b>{range.quantity}x</b>
      </div>
      <div
        style={{
          padding: '16px 32px',
          boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)',
          // boxShadow: '0px 10px 35px 4px rgba(0,0,0,0.1)',
          borderRadius: 16,
          display: 'flex',
          alignItems: 'center',
          gap: 16,
        }}
      >
        <ImageDispatcher
          src={range.image}
          alt={range.name}
          style={{ height: 80, width: 80, objectFit: 'contain' }}
        />
        <div>
          {range.productName}
          <div style={{ display: 'flex', gap: 8 }}>
            <div style={{ textDecoration: 'line-through' }}>
              € {range.calculatedPrice}
            </div>
            <b>€ 0,00</b>
          </div>
        </div>
      </div>
    </Link>
  );
};
